import "../../../../src/pages/styles/main.css";
import bgImg from "../../../../src/pages/images/Summary-background.svg";
import SpaceContent from "../../../../src/pages/adobe-express/spaceAbility.md";
import LearnMore from "../../../../src/pages/adobe-express/learnmore.md";
import * as React from 'react';
export default {
  bgImg,
  SpaceContent,
  LearnMore,
  React
};